import styled from 'styled-components'

/**
 * O corpo da tabela e a paginação usam margens negativas para encostar no
 * header, o que fazia as linhas roladas aparecerem por cima do header e do
 * rodapé. A paginação (último filho, renderizado pelo BodyTable logo após o
 * corpo) sobe no empilhamento para cobrir as linhas ao rolar. O header recebe
 * o mesmo tratamento via style no index.
 */
export const ContainerTabela = styled.div`
  > div:last-child {
    position: relative;
    z-index: 1;
  }
`
